import React from "react";
import { Button, Tooltip, Typography, Space } from "antd";
import { FullscreenOutlined, FullscreenExitOutlined, MailOutlined, SendOutlined } from "@ant-design/icons";

const { Title } = Typography;

/**
 * 邮件编辑器头部组件
 */
const EmailEditorHeader = ({ title, fullscreen, onToggleFullscreen, onSend, sendLoading = false }) => (
    <div className="email-editor-header">
        <div className="header-left">
            <MailOutlined className="header-icon" />
            <Title level={4} className="header-title">
                {title}
            </Title>
        </div>
        <div className="header-right">
            <Space>
                <Button type="primary" ghost icon={fullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />} onClick={onToggleFullscreen}>
                    {fullscreen ? "退出全屏" : "全屏模式"}
                </Button>
            </Space>
        </div>
    </div>
);

export default EmailEditorHeader;
